module.exports = __webpack_public_path__ + "static/media/double-right-pagination.a6a0bb2a.svg";